<mat-form-field class="w-100">
  <mat-label>{{ label }}</mat-label>
  <mat-select [formControl]="ctrl" multiple [panelClass]="cls">
    <mat-option *ngFor="let d of data" [value]="d">{{ d }}</mat-option>
  </mat-select>
</mat-form-field>
